import { BrowserRouter } from 'react-router-dom';

// isolated module for simpler mocking
const AppRouter = BrowserRouter;

export default AppRouter;
